import { useQuery } from '@tanstack/react-query';

import { AttachmentClient, ReportType } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const attachmentClient = new AttachmentClient(apiBaseUrl);

function useGetAttachmentsForEventReport(id: number | undefined, reportType: ReportType) {
  return useQuery({
    queryKey: [queryKeys.Attachment.Get, { id, reportType }],
    queryFn: () => {
      if (id) return attachmentClient.getAttachmentsForEventReport(id, reportType);
      throw new TypeError('ReportId cannot be undefined');
    },
  });
}

export default useGetAttachmentsForEventReport;
